<ng-template #modalContentTemplate>
  <div class="udex-mb-32 udex-pt-8">
    <udex-message-strip design="Information" status-type="Icon" hide-close-button data-cy="info-message">
      <div class="body--s">
        <span>
          {{
            'configurator.partOfBundle'
              | cxTranslate
                : {
                    productName: this.productName,
                    product: this.product,
                  }
          }}
        </span>
        <span>
          {{ 'configurator.orderUpsellBundle' | cxTranslate }}
        </span>
      </div>
    </udex-message-strip>
  </div>
  <table class="derivative-parents w-100">
    <thead>
      <tr>
        <th class="derivative-parents__subtitle body--xs udex-pb-12" colspan="2" data-cy="sub-title">
          {{ 'configurator.yourSolutions' | cxTranslate }}
        </th>
      </tr>
    </thead>
    <tbody>
      @if (parentProductName && parentProduct) {
        <tr class="derivative-parents__product-name">
          <td class="body--xs udex-py-8">{{ parentProductName }} ({{ parentProduct }})</td>
          <td class="udex-py-8 udex-ps-24 navigation__medium--m">
            <udex-button class="navigation__medium--m" size="Medium" design="Tertiary" (click)="addParentLicense()">
              {{ 'configurator.addLicense' | cxTranslate }}
            </udex-button>
          </td>
        </tr>
      }
      @for (derivativeParent of derivativeParents; track derivativeParent) {
        <tr class="derivative-parents__product-name">
          <td data-cy="product-name" class="body--xs udex-py-8">
            {{ derivativeParent.name }} ({{ derivativeParent.id }})
          </td>
          <td data-cy="add-license-cta" class="udex-py-8 udex-ps-24">
            <udex-button
              class="navigation__medium--m"
              size="Medium"
              design="Tertiary"
              (click)="addDerivativeLicense(derivativeParent.id)">
              {{ 'configurator.addLicense' | cxTranslate }}
            </udex-button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</ng-template>
